import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

import pathName from './pathName.constant'
import {
  getUserList,
  getUserProfileApi,
} from '../components/userManagement/user.api'
import useRedux from '../hooks/useRedux'
import useRouter from '../hooks/useRouter'
import { profileDetails } from '../redux/user_management/reducer'
import { getItem, setItem } from '../utils/localstorage'

const ProtectedRoute = ({ children }) => {
  const isAuth = getItem('token')
  const adminId = getItem('adminId')
  const { queryParams } = useRouter()
  const code = queryParams.get('code')
  let navigatePath = pathName.LOGIN
  const userData = JSON.parse(getItem('userData'))
  const { dispatch } = useRedux()

  useEffect(() => {
    const getProfile = async () => {
      const response = await getUserProfileApi({
        id: userData?.id,
      })
      if (response?.data?.data) {
        const updatedProfile = { ...userData, ...response?.data?.data }
        dispatch(profileDetails(updatedProfile))
        setItem('userData', JSON.stringify(updatedProfile))
        if (!adminId) {
          const params = `${1}?roleId=${1}`
          const resp = await getUserList({ params })
          if (resp?.data) {
            setItem('adminId', resp?.data?.list?.[0]?.id)
          }
        }
      }
    }
    if (isAuth) getProfile()
  }, [])

  if (code) navigatePath += `?code=${code}`

  return isAuth ? children : <Navigate to={navigatePath} replace={true} />
}

export default ProtectedRoute
